export enum names {
  Мужчина = "Мужчина",
  Женщина = "Женщина",
  IT = "IT",
  Маркетинг = "Маркетинг",
  Бухгалтерия = "Бухгалтерия",
  Сотрудник = "Сотрудник",
  Начальник = "Начальник",
}
